import React, { useMemo } from 'react';

import { IonCard, IonCardContent } from '@ionic/react';

import clsx from 'clsx';

import ProgressBar from 'components/ProgressBar';
import Typography from 'components/Typography';
import { useCurrencyFormat, useNumberFormat, usePercentFormat } from 'intl';

import './index.css';

interface ISummaryCard {
  label: string;
  value: number;
  metricType: string;
  precision?: number;
  isRefetching?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  error?: any;
}
const SummaryCard = ({
  label = 'Metric',
  value,
  metricType,
  isRefetching,
  isError,
  error,
}: ISummaryCard) => {
  const numberFormat = useNumberFormat({
    maximumFractionDigits: 0,
    notation: 'compact',
    compactDisplay: 'short',
  });
  const percentFormat = usePercentFormat({
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 2,
  });
  const currencyFormat = useCurrencyFormat({
    currency: 'USD',
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 2,
  });

  const formattedValue = useMemo(() => {
    if (value === undefined || value === null) {
      return '—';
    }
    switch (metricType) {
      case 'number':
        return numberFormat(value);
      case 'percent':
        return percentFormat(value);
      case 'currency':
        return currencyFormat(value);
    }
  }, [metricType, value]);

  return (
    <IonCard className={'summary-card border radius'}>
      <div
        className={clsx({
          'summary-card-overlay': true,
          'summary-card-refetching': isRefetching,
        })}
      />
      <IonCardContent>
        <Typography variant={'overline'} color={'medium-shade'}>
          {label}
        </Typography>
        {isError ? (
          <Typography color={'danger-tint'}>{error}</Typography>
        ) : (
          <h2>{formattedValue}</h2>
        )}
      </IonCardContent>
      {isRefetching && <ProgressBar type={'indeterminate'} />}
    </IonCard>
  );
};
export default SummaryCard;
